import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ErrorIcon from "@mui/icons-material/Error";
import { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import _get from "lodash/get";
import brandclub_colors from "../../../colors/brandclubColors.js";
import { Typography } from "@mui/material";
import { ButtonLoadingEllipsis } from "../Loading/index.js";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber.js";
import { Button } from "../../../Components/Button/Button.js";
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from "../../../utils/constants/Constants.js";
const QRCodeContainer = styled(Grid)({
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    display: "none"
  }
});
var BCPhoneInputVariant = /* @__PURE__ */ ((BCPhoneInputVariant2) => {
  BCPhoneInputVariant2["DEFAULT"] = "default";
  BCPhoneInputVariant2["XS"] = "xs";
  BCPhoneInputVariant2["SM"] = "sm";
  BCPhoneInputVariant2["DRAWER"] = "drawer";
  BCPhoneInputVariant2["DRAWER_MOBILE"] = "drawer-mobile";
  return BCPhoneInputVariant2;
})(BCPhoneInputVariant || {});
const variantStyles = {
  [
    "default"
    /* DEFAULT */
  ]: {
    container: {
      maxWidth: "100%"
    },
    inputContainer: {
      height: 56,
      minWidth: 345,
      borderWidth: 1.5
    },
    input: {
      fontSize: 20,
      margin: "0 0 0 10px"
    },
    prefix: {
      fontSize: 18,
      marginLeft: 20
    },
    button: {
      fontSize: 18,
      width: 134,
      height: 46
    }
  },
  [
    "xs"
    /* XS */
  ]: {
    container: {
      maxWidth: 269
    },
    inputContainer: {
      height: 39.1,
      minWidth: 269,
      borderWidth: 1
    },
    input: {
      fontSize: 14,
      margin: "0 0 0 7px"
    },
    prefix: {
      fontSize: 14,
      marginLeft: 7
    },
    button: {
      fontSize: 14,
      width: 91,
      height: 29
    }
  },
  [
    "sm"
    /* SM */
  ]: {
    container: {
      maxWidth: 314
    },
    inputContainer: {
      height: 46.4,
      minWidth: 314,
      borderWidth: 1.5
    },
    input: {
      fontSize: 14,
      margin: "0 0 0 7px"
    },
    prefix: {
      fontSize: 14,
      marginLeft: 7
    },
    button: {
      fontSize: 14,
      width: 106,
      height: 35
    }
  },
  [
    "drawer"
    /* DRAWER */
  ]: {
    container: {
      maxWidth: 345
    },
    inputContainer: {
      height: 55,
      minWidth: 345,
      borderWidth: 1.5
    },
    input: {
      fontSize: 16,
      margin: "0 0 0 10px"
    },
    prefix: {
      fontSize: 16,
      marginLeft: 20
    },
    button: {
      fontSize: 16,
      width: 134,
      height: 46
    }
  },
  [
    "drawer-mobile"
    /* DRAWER_MOBILE */
  ]: {
    container: {
      maxWidth: 288
    },
    inputContainer: {
      height: 49,
      minWidth: 288,
      borderWidth: 1.5,
      padding: "0 3px"
    },
    input: {
      fontSize: 14,
      margin: "0 0 0 7px"
    },
    prefix: {
      fontSize: 14,
      marginLeft: 7
    },
    button: {
      fontSize: 14,
      width: 80,
      height: 40
    }
  }
};
const InputContainer = styled(Grid, {
  shouldForwardProp: (prop) => !["variant"].includes(prop.toString())
})(({ variant, theme }) => {
  const variantStyle = variantStyles[variant];
  return {
    width: "100%",
    position: "relative",
    ...variantStyle.container,
    ".textme_header": {
      fontWeight: 600,
      color: theme.vars.palette.text.primary,
      fontSize: 18,
      marginBottom: 10,
      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        display: "none"
      }
    },
    ".textme_input": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      borderStyle: "solid",
      borderColor: theme.vars.palette.primary.main,
      borderRadius: 100,
      backgroundColor: "#fff",
      padding: "0 5px",
      maxWidth: 400,
      width: "100%",
      boxSizing: "border-box",
      ...variantStyle.inputContainer,
      ".text_prefix": {
        color: theme.vars.palette.text.primary,
        fontWeight: 500,
        ...variantStyle.prefix,
        "&.sent": {
          display: "none"
        }
      },
      input: {
        fontFamily: "Poppins",
        width: 0,
        flex: 1,
        color: theme.vars.palette.text.primary,
        backgroundColor: "#fff",
        fontWeight: 500,
        border: 0,
        outline: "none",
        ...variantStyle.input,
        "&.sent": {
          display: "none"
        },
        "&::placeholder": {
          color: "#a7afc4"
        }
      },
      ".text_button": {
        cursor: "pointer",
        fontWeight: 500,
        marginRight: 0,
        border: 0,
        backgroundColor: theme.vars.palette.primary.main,
        color: theme.vars.palette.primary.contrastText,
        borderRadius: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        ...variantStyle.button,
        "&.sent": {
          width: "100%"
        }
      }
    },
    ".textme_button_group": {
      display: "none",
      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        display: "flex",
        marginTop: 15,
        gap: "10px",
        button: {
          borderWidth: 1,
          borderStyle: "solid",
          outline: "none",
          borderRadius: 100,
          height: 40,
          fontSize: 16,
          "&.download": {
            borderColor: theme.vars.palette.primary.main,
            color: theme.vars.palette.text.primary,
            background: "rgba(158,224,208,.2)",
            flex: 1
          },
          "&.text_link": {
            flex: 1,
            borderColor: theme.vars.palette.primary.main,
            color: brandclub_colors.white,
            background: theme.vars.palette.primary.main
          }
        }
      }
    }
  };
});
const ErrorMessage = ({ children, ...props }) => {
  if (!children) {
    return null;
  }
  const lineHeight = 1.5;
  return /* @__PURE__ */ jsxs(
    Typography,
    {
      ...props,
      sx: (theme) => ({
        color: theme.vars.palette.error.main,
        backgroundColor: theme.vars.palette.error.light,
        fontSize: 14,
        marginTop: 2.5,
        padding: "7px 12px 7px 9px",
        display: "flex",
        alignItems: "flex-start",
        width: "max-content",
        borderRadius: 1,
        fontWeight: 600,
        lineHeight
      }),
      children: [
        /* @__PURE__ */ jsx(Box, { component: "span", display: "flex", alignItems: "center", height: `${lineHeight}em`, children: /* @__PURE__ */ jsx(ErrorIcon, { sx: { paddingRight: 0.75, fontSize: 18 } }) }),
        children
      ]
    }
  );
};
const getSendStatusMessage = (sendStatus, defaultMessage) => {
  switch (sendStatus) {
    case "sending":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        "Sending",
        /* @__PURE__ */ jsx(ButtonLoadingEllipsis, { baseFontSize: 17 })
      ] });
    case "sent":
      return "Text sent!";
    default:
      return defaultMessage;
  }
};
const BrandclubPhoneInput = ({
  handleSendText,
  qrCodeUrl,
  hasHeader = true,
  buttonText = "Send Text",
  variant,
  onTextSent,
  userProfile
}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [sendStatus, setSendStatus] = useState("normal");
  const desktopView = useMediaQuery(`(min-width:${TABLET_SCREEN_SIZE}px)`);
  const mobileView = useMediaQuery(`(max-width:${MOBILE_SCREEN_SIZE}px)`);
  const isSignedIn = !!userProfile;
  const userPhoneNumber = userProfile == null ? void 0 : userProfile.phoneNumber;
  const variantToUse = variant ? variant : desktopView ? "default" : mobileView ? "xs" : "sm";
  useEffect(() => {
    if (sendStatus === "sent") {
      setTimeout(() => {
        setSendStatus("normal");
        setPhoneNumber("");
      }, 3e3);
    }
  }, [sendStatus]);
  const sendText = async () => {
    try {
      let number = userPhoneNumber ?? phoneNumber;
      number = number.replace(/\D/g, "");
      setSendStatus("sending");
      const res = await handleSendText(number);
      const sentStatus = _get(res, ["waitListEntry", "textInvitationStatus"]);
      if (sentStatus === "sent") {
        if (onTextSent) onTextSent();
        setSendStatus("sent");
      } else {
        setSendStatus("failed");
      }
    } catch (e) {
      setSendStatus("failed");
    }
  };
  return /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", children: [
    qrCodeUrl && /* @__PURE__ */ jsx(QRCodeContainer, { children: /* @__PURE__ */ jsx(QRCode, { value: qrCodeUrl, fgColor: "#181d56", size: 95 }) }),
    /* @__PURE__ */ jsxs(InputContainer, { container: true, flexDirection: "column", variant: variantToUse, children: [
      hasHeader && /* @__PURE__ */ jsx("div", { className: "textme_header", children: "Download the app to access rewards" }),
      isSignedIn && userPhoneNumber ? /* @__PURE__ */ jsx(
        Button,
        {
          sx: {
            height: 50,
            maxWidth: 355,
            width: "100%",
            fontSize: 16,
            alignSelf: "center",
            [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
              height: 40,
              fontSize: 12,
              maxWidth: 300
            }
          },
          onClick: ["normal", "failed"].includes(sendStatus) ? sendText : void 0,
          disabled: sendStatus === "sending",
          children: getSendStatusMessage(sendStatus, `Text link to ${formatPhoneNumber(userPhoneNumber)}`)
        }
      ) : /* @__PURE__ */ jsxs("div", { className: `textme_input`, children: [
        /* @__PURE__ */ jsx("div", { className: `text_prefix ${sendStatus}`, children: "+1" }),
        /* @__PURE__ */ jsx(
          "input",
          {
            className: `phone_input ${sendStatus}`,
            name: "phone_number",
            placeholder: "Phone number",
            value: phoneNumber,
            type: "tel",
            onChange: (e) => {
              setSendStatus("normal");
              setPhoneNumber(e.target.value);
            }
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            className: `text_button ${sendStatus}`,
            style: {
              minWidth: "max-content"
            },
            onClick: ["normal", "failed"].includes(sendStatus) ? sendText : void 0,
            disabled: sendStatus === "sending",
            children: getSendStatusMessage(sendStatus, buttonText)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx(ErrorMessage, { children: sendStatus === "failed" && "Failed to send text. Please try again." })
  ] });
};
export {
  BCPhoneInputVariant,
  BrandclubPhoneInput as default
};
//# sourceMappingURL=index.js.map
